"use client";

import { Eye, EyeOff } from "lucide-react";
import { cn } from "@/lib/utils";

// DESIGN.md § header (L517) "square ghost button" + § A11Y (L409) focus
// ring. A 40×40 squared toggle that reveals/masks the password field it
// sits inside. Icon in --muted, hover --ink; gold focus ring drawn
// `inset` (the documented ring uses an offset, but this control overlays
// a white input, so an inset ring reads cleanly without an offset-colour
// mismatch). `aria-pressed` conveys the on/off state to assistive tech;
// the label names the action. Shared by the auth `PasswordInput` and the
// portal `TextInput` so every password field reveals identically.
export function PasswordRevealButton({
  revealed,
  onToggle,
  className,
}: {
  revealed: boolean;
  onToggle: () => void;
  className?: string;
}) {
  return (
    <button
      type="button"
      onClick={onToggle}
      // Keep focus on the input when toggling with the mouse.
      onMouseDown={(e) => e.preventDefault()}
      aria-pressed={revealed}
      aria-label={revealed ? "Hide password" : "Show password"}
      className={cn(
        "absolute inset-y-0 right-0 grid w-10 place-items-center text-[color:var(--color-muted)] transition-colors hover:text-[color:var(--color-ink)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[color:var(--color-accent)]",
        className,
      )}
    >
      {revealed ? (
        <EyeOff width={16} height={16} aria-hidden="true" />
      ) : (
        <Eye width={16} height={16} aria-hidden="true" />
      )}
    </button>
  );
}
